import React from 'react'
import { PropTypes } from 'prop-types'
import ShareButton from '../shareButton/ShareButton'

const LastScene = ({
  image,
  title,
  subtitle,
  author,
  editMode,
  social,
  shareTitle,
  shareSubtitle,
  setShareButtonsVisible,
  shareButtonVisible
}) => {

  const onSubtitleClick = () => {
    const r = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm
    const isUrl = r.test(subtitle)
    // console.log('onSubtitleClick', isUrl, editMode)
    if (!editMode && isUrl) {
      const url = subtitle.match(/^http[s]*:\/\//) ? subtitle : 'https://' + subtitle
      // console.log('onSubtitleClick url', url)
      window.open(url, '_self')
    }
  }

  return (
    <div className='swiper-slide slide'>
      <div
        id='ou_last-scene_image'
        style={{backgroundImage: `url(${image})`}}
        className='ou_showcase__image ou_last-scene_image'
      />
      <div
        id='ou_last-scene_image_preview'
        className='ou_showcase__image ou_last-scene_image'
      />
      <div className='ou_showcase__content'>
        <div id='ou_last-scene_title' className='ou_showcase__title'>
          <span className='ou_showcase__title--text'>{title}</span>
        </div>
        <div className='ou_showcase__line' />
        <div id='ou_last-scene_author' className='ou_showcase__author'>
          <span className='ou_showcase__author--text'>{author}</span>
        </div>
        <div onClick={onSubtitleClick} id='ou_last-scene_subtitle' className='ou_showcase__subtitle'>
          <span className='ou_showcase__subtitle--text'>{subtitle}</span>
        </div>
      </div>
      <div>
        { shareButtonVisible &&
          <ShareButton
            shareTitle={shareTitle}
            shareSubtitle={shareSubtitle}
            twitter={social ? social.twitter : ''}
            facebook={social ? social.facebook : ''}
            email={social ? social.email : ''}
            phone={social ? social.phone : ''}
            setShareButtonsVisible={setShareButtonsVisible}
          />
        }
      </div>
    </div>
  )
}

LastScene.defaultProps = {
  shareButtonVisible: true
}

LastScene.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  author: PropTypes.string,
  editMode: PropTypes.bool,
  social: PropTypes.object,
  shareTitle: PropTypes.string,
  shareSubtitle: PropTypes.string,
  setShareButtonsVisible: PropTypes.func,
  shareButtonVisible: PropTypes.bool
}

export default LastScene



// WEBPACK FOOTER //
// ./src/templates/outSide/components/scenes/LastScene.js